var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeypadRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    viewBox: "0 0 51 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 11.3387C24.4999 12.1744 25.1496 12.8241 25.9853 12.8241H32.3386C33.1743 12.8241 33.824 12.1744 33.824 11.3387V4.9854C33.824 4.14972 33.1743 3.5 32.3386 3.5H25.9853C25.1496 3.5 24.4999 4.14972 24.4999 4.9854V11.3387Z",
    fill: "white",
    stroke: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.865 34.9695C37.865 36.4799 39.8454 37.0433 40.6404 35.759L49.2882 21.7895C49.5877 21.3058 49.5877 20.6942 49.2882 20.2105L40.6404 6.24096C39.8454 4.95672 37.865 5.52009 37.865 7.03049V34.9695Z",
    fill: "white",
    stroke: "#121212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 22,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 33.365 27.3242)",
    fill: "white",
    stroke: "#121212"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 33.0969 15.3242)",
    fill: "white",
    stroke: "#121212"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 21.0969 15.3242)",
    fill: "white",
    stroke: "#121212"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 21 3)",
    fill: "white",
    stroke: "#121212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 9 3)",
    fill: "white",
    stroke: "#121212"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 9.09692 15.3242)",
    fill: "white",
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadRight);
export default __webpack_public_path__ + "static/media/keypad_right.12c571929b5a267cdd6ab486bdae1e6c.svg";
export { ForwardRef as ReactComponent };